import React, { useState } from 'react';
import { ContentWrapper, ExpandableContent, StyledTableRow } from './Styled';
import { Customer } from '../../../../data/entities';
import { AddCustomerTableColumns } from '../../../../configs/customer';
import { api } from '../../../../shared/hooks/api';
import PaginationBar from '../../../../shared/components/PaginationBar';
import SearchBar from '../../../../shared/components/SearchBar';
import CustomTable from '../../../../shared/components/CustomTable';
import { StyledTableCell } from '../../../../shared/components/CustomTable/Styled';
import { CategoryContainer } from '../../../../shared/components/CustomTable/Styled';
import { DEFAULT_PAGE_SIZE } from '../../../../configs/apiConfig';
import Status from '../../../../shared/components/Status';
import { PRODUCT_CATEGORY } from '../../../../data/enums';
import { ProductFilterType, valueToText } from '../../../../configs/filterTypes';
import styled from 'styled-components';

interface ProductOrderRowProps {
    item: Customer;
    extraRowProps: any;
}

const getCategoryColorTheme = (category: string) => {
    switch (category) {
        case PRODUCT_CATEGORY.BARREL:
            return 'SUCCESS';
        case PRODUCT_CATEGORY.VESSEL:
            return 'WARNING';
        case PRODUCT_CATEGORY.VEHICLE:
            return 'INFO';
        default:
            return 'INFO';
    }
};

const StyledStatus = styled(Status)`
    flex-shrink: 0;
    flex: 0 1 auto;
    min-width: 0;
`;

const ProductOrderRow = ({ item, extraRowProps }: ProductOrderRowProps) => {
    const categories = item.category?.split(';').filter(Boolean) || [];
    
    return (
        <StyledTableRow onClick={() => extraRowProps.setSelectedCustomer(item)}>
            <StyledTableCell align="left">{item.customer_code ? item.customer_code : item.id}</StyledTableCell>
            <StyledTableCell align="left">{item.name}</StyledTableCell>
            <StyledTableCell align="left">
                <CategoryContainer>
                    {categories.map((category) => (
                        <StyledStatus
                            key={category}
                            colorTheme={getCategoryColorTheme(category)}
                            text={valueToText(ProductFilterType, "category", category) || category}
                            width="auto"
                        />
                    ))}
                </CategoryContainer>
            </StyledTableCell>
            <StyledTableCell align="left">{item.phone}</StyledTableCell>
            <StyledTableCell align="left">{item.email}</StyledTableCell>
        </StyledTableRow>
    );
};

const SelectCustomers = ({ setSelectedCustomer }: { setSelectedCustomer: Function }) => {
    const [{ data, variables, error, isLoading }, fetchCustomers] = api.get('/customers/', { page_size: DEFAULT_PAGE_SIZE });
    const [currentPage, setCurrentPage] = useState(1);
    const customers = data && data.results ? data.results : [];
    const totalItems = data && data.count ? data.count : 0;
    const pageSize = variables && variables.page_size ? variables.page_size : DEFAULT_PAGE_SIZE;

    return (
        <ContentWrapper>
            <ExpandableContent>
                Vui lòng lựa chọn khách hàng
                <SearchBar placeholder="Tìm kiếm theo từ khoá Mã khách hàng, Tên khách hàng" fetchItems={fetchCustomers} />
                <CustomTable
                    itemList={customers}
                    RowElement={ProductOrderRow}
                    TableColumns={AddCustomerTableColumns}
                    extraRowProps={{ setSelectedCustomer }}
                />
            </ExpandableContent>

            <PaginationBar
                totalItems={totalItems}
                pageSize={pageSize}
                fetchItems={fetchCustomers}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />
        </ContentWrapper>
    );
};

export default SelectCustomers;
